import { IPoint } from "utils/types";


class _CurrentLocationModel {
  subscribers:((point:IPoint)=>void)[];
  point:IPoint|null;

  constructor() {
    this.point = null;
    this.subscribers = [];

    if(!!navigator.geolocation) {
      navigator.geolocation.watchPosition(this.watchGeoPosition, (err)=>{
        console.warn('ERROR(' + err.code + '): ' + err.message);
      }, {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 0
      });
    }
  }

  subscribe = (callback:(point:IPoint)=>void) => {
    this.subscribers.push(callback);
  }
  unsubscribe = (callback:(point:IPoint)=>void) => {
    this.subscribers = this.subscribers.filter((c)=>c!==callback);
  }

  protected watchGeoPosition = (pos:GeolocationPosition) => {
    this.point = {
      type: "Point",
      coordinates: [pos.coords.latitude, pos.coords.longitude]
    }
    this.subscribers.map((callback)=>{
      if(this.point){
        callback(this.point);
      }
      return callback;
    });
  }
}


const CurrentLocationModel = new _CurrentLocationModel();
export default CurrentLocationModel;